import { useEffect, useState } from "react";
import RecapFilters from "../filters/recapfilters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import RecapTable from "../tables/recaptable";
import dayjs from "dayjs";
import api from "../api/api";
import isoWeek from "dayjs/plugin/isoWeek";
import { CircularProgress, Box, Backdrop } from "@mui/material"; // Import MUI Loader
import Sidenav from "../Sidenav/Sidenav";
import SideNavLayout from "../Sidenav/SideNavLayout";
import { useSelector } from "react-redux";
import RecapHistory from "./recaphistory";
dayjs.extend(isoWeek);
const Recap = () => {
  const getWeekRange = (date) => {
    const startOfWeek = date.startOf("isoWeek"); // Start of the week (Monday)
    const endOfWeek = date.endOf("isoWeek"); // End of the week (Sunday)
    return {
      startDate: startOfWeek,
      endDate: endOfWeek,
    };
  };

  const updateWeek = (direction) => {
    const newDate =
      direction === "prev"
        ? currentDate.startDate.subtract(1, "week")
        : currentDate.startDate.add(1, "week");
    setCurrentDate(getWeekRange(newDate));
  };
  const [filterType, setFilterType] = useState("all");
  const [currentDate, setCurrentDate] = useState(getWeekRange(dayjs()));
  const [loading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [originaldata, setOriginalData] = useState([]);
  const [backupData, setBackupData] = useState([]);
  const [ui, setUi] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([
    // { label: 'All', value: "ALL" },
    { label: "Pending", count: "0", value: "PENDING" }, // Fix the key here (was "Value")
    { label: "Submitted", count: "0", value: "SUBMITTED" },
  ]);
  const [searchqueary, setSearchQueary] = useState();
  const [activeFilter, setActiveFilter] = useState("SUBMITTED");
  const [buttons, setButtons] = useState({});
  const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
  const user = useSelector((state) => state.user.userDetails);

  const fetchData = async () => {
    try {
      setTableLoading(true);
      const response = await api.get(`v1/timesheets/recap`, {
        params: {
          start_date: currentDate.startDate.format("YYYY-MM-DD"),
          end_date: currentDate.endDate.format("YYYY-MM-DD"),
          company_id: selectedCompanyId,
          status: activeFilter,
          ...(user &&
            !["Admin", "Project Manager"].includes(user?.user_roles?.role) && {
              supervisor_id: user.phone,
            }),
        },
      });

      if (response.status === 200 && response.data.length > 0) {
        const defaultData = response.data[0];
        setTableData(defaultData);
        setOriginalData(defaultData);
        setBackupData(defaultData);
      } else {
        setTableData({});
        setBackupData({});
        setOriginalData({});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTableLoading(false);
      setSearchQueary("");
    }
  };

  useEffect(() => {
    if (currentDate?.startDate && activeFilter && selectedCompanyId) {
      fetchData();
    }
  }, [currentDate, activeFilter, selectedCompanyId]);

  // const handleButtonClick = (companyName) => {
  //   const updatedButtons = Object.keys(buttons).reduce((acc, name) => {
  //     acc[name] = { ...buttons[name], isSelected: name === companyName };
  //     return acc;
  //   }, {});

  //   setButtons(updatedButtons);
  //   setTableData(buttons[companyName].data); // Update table data
  // }

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQueary(query);

    if (!query) {
      setTableData(backupData);
      return;
    }

    // 🔒 Safe check for emp_report
    const empReport = backupData?.emp_report;
    if (!empReport || typeof empReport !== "object") {
      setTableData({ ...backupData, emp_report: {} });
      return;
    }

    // Filter the employees based on emp_id or emp_name
    const filteredEmpReport = Object.fromEntries(
      Object.entries(empReport).filter(
        ([key, value]) =>
          value.emp_name?.toLowerCase().includes(query) ||
          value.emp_id?.toString().includes(query),
      ),
    );

    const filteredData = {
      ...backupData,
      emp_report: filteredEmpReport,
    };

    setTableData(filteredData);
  };

  const fetchTabsData = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);

      if (response.status === 200) {
        setCompanyTabs(response.data);
        if (user?.user_roles?.role === "Project Manager") {
          setSelectedCompanyId(user?.user_info?.company_id);
        } else {
          // Default for others
          setSelectedCompanyId(response.data[0]?.id);
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchTabsData();
  }, []);

  const handleCompanyTabClick = (companyId) => {
    setSelectedCompanyId(companyId);
  };
  useEffect(() => {
    if (
      !originaldata?.emp_report ||
      typeof originaldata.emp_report !== "object"
    )
      return;

    // ALL → return original data
    if (filterType === "all") {
      setBackupData(originaldata);
      setTableData(originaldata);
      return;
    }

    // map dropdown value to etype
    const REQUIRED_ETYPE =
      filterType === "emp" ? "EMP" : filterType === "eqp" ? "EQP" : null;

    if (!REQUIRED_ETYPE) return;

    const filteredEmpReport = Object.fromEntries(
      Object.entries(originaldata.emp_report)
        .map(([key, emp]) => {
          // check etype in ANY activity (1st, 2nd, 3rd…)
          const hasEtype = emp.activity?.some((activity) =>
            activity.work_details?.some((wd) => wd.etype === REQUIRED_ETYPE),
          );

          // remove entire emp if etype not found
          if (!hasEtype) return null;

          // keep emp, filter work_details in ALL activities
          return [
            key,
            {
              ...emp,
              activity: emp.activity.map((activity) => ({
                ...activity,
                work_details: activity.work_details.filter(
                  (wd) => wd.etype === REQUIRED_ETYPE,
                ),
              })),
            },
          ];
        })
        .filter(Boolean),
    );

    // keep full original structure
    const finalData = {
      ...originaldata,
      emp_report: filteredEmpReport,
    };

    setBackupData(finalData);
    setTableData(finalData);
  }, [filterType, originaldata]);

  return (
    <>
      <SideNavLayout>
        <div
          className="flex bg-gray-100 max-h-[90vh] overflow-y-auto "
          style={{ scrollbarWidth: "none" }}
        >
          <div className="sm:pt-7  w-full mb-12 min-h-screen ">
            <RecapFilters
              selectedRows={selectedRows}
              filters={currentFilter}
              setTableLoading={setTableLoading}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              startDate={currentDate.startDate.format("YYYY-MM-DD")}
              endDate={currentDate.endDate.format("YYYY-MM-DD")}
              selectedCompanyId={selectedCompanyId}
              setui={setUi}
              ui={ui}
              fetchData={fetchData}
              filterddata={tableData}
              isFilterType={filterType}
            />
            {ui == 0 ? (
              <>
                <div className="flex items-center space-x-4 w-full px-4">
                  <div className="flex items-center h-10 rounded-md border border-gray-300 bg-white px-4 flex-grow">
                    <FontAwesomeIcon
                      icon={faSearch}
                      className="text-gray-500 mr-2 cursor-pointer"
                    />
                    <input
                      type="text"
                      value={searchqueary}
                      onChange={(e) => handleSearch(e)}
                      placeholder="Search employees..."
                      className="w-full bg-transparent outline-none text-gray-700"
                    />
                  </div>
                </div>
                <div className="mt-4 flex justify-between">
                  <div className="flex gap-2">
                    <div className="flex gap-2 px-4 pb-1">
                      {companyTabs.map((company) => {
                        const isProjectManager =
                          user?.user_roles?.role === "Project Manager";
                        const isCurrentUserCompany =
                          company.id == user?.user_info?.company_id;

                        return (
                          <button
                            key={company.id}
                            disabled={isProjectManager && !isCurrentUserCompany} // ✅ Disable if not their company
                            className={`px-4 py-1 border text-[13px] rounded-[5px] ${
                              selectedCompanyId === company.id
                                ? "border-red-400 bg-white font-inter"
                                : "border-[#DBDBDB] bg-[#F2F2F2] text-[#000000CC]"
                            } ${
                              isProjectManager && !isCurrentUserCompany
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={() => {
                              if (!isProjectManager || isCurrentUserCompany) {
                                handleCompanyTabClick(company.id);
                              }
                            }}
                          >
                            {company.name ===
                            "INSTRUMENTATION & ELECTRICAL (I&E)"
                              ? "I&E"
                              : company.name}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div></div>

                  <div className="flex items-center gap-4">
                    <div className="px-2 py-2 border-[1.5px] mb-2 text-[13px] font-inter border-[#DBDBDB] rounded-[5px] bg-white w-fit">
                      <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        className="bg-transparent outline-none cursor-pointer"
                      >
                        <option value="all">All</option>
                        <option value="emp">Employee</option>
                        <option value="eqp">Equipment</option>
                      </select>
                    </div>
                    <button
                      onClick={() => updateWeek("prev")}
                      className="p-2 rounded-md"
                    >
                      <FontAwesomeIcon
                        icon={faChevronLeft}
                        className="text-[#293050] text-sm"
                      />
                    </button>

                    <span className="text-[#293050] font-medium">
                      {currentDate.startDate.format("DD MMM, YYYY")} -{" "}
                      {currentDate.endDate.format("DD MMM, YYYY")}
                    </span>

                    <button
                      onClick={() => updateWeek("next")}
                      className="p-2 rounded-md"
                    >
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="text-[#293050] text-sm"
                      />
                    </button>
                  </div>
                </div>
                {loading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="200px"
                  >
                    <CircularProgress size={50} />
                  </Box>
                ) : (
                  <RecapTable
                    data={tableData}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    fetchData={fetchData}
                    startDate={currentDate.startDate.format("YYYY-MM-DD")}
                    endDate={currentDate.endDate.format("YYYY-MM-DD")}
                    isFilterType={filterType}
                  />
                )}
              </>
            ) : (
              <>
                <RecapHistory />
              </>
            )}

            <Backdrop
              open={loading}
              sx={{
                zIndex: 9999,
                backgroundColor: "rgba(0, 0, 0, 0.1)", // reduce darkness here
              }}
            ></Backdrop>

            {/* MUI Loader */}
          </div>
        </div>
      </SideNavLayout>
    </>
  );
};

export default Recap;
